import { render, staticRenderFns } from "./LayoutsEdit.vue?vue&type=template&id=27e7dcee"
import script from "./LayoutsEdit.vue?vue&type=script&lang=js"
export * from "./LayoutsEdit.vue?vue&type=script&lang=js"
import style0 from "./LayoutsEdit.vue?vue&type=style&index=0&id=27e7dcee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports